import { render, staticRenderFns } from "./DadosBasicos.vue?vue&type=template&id=9bcdc16a&scoped=true&"
import script from "./DadosBasicos.vue?vue&type=script&lang=ts&"
export * from "./DadosBasicos.vue?vue&type=script&lang=ts&"
import style0 from "./DadosBasicos.vue?vue&type=style&index=0&id=9bcdc16a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcdc16a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDivider,VRadio,VRadioGroup,VRow,VSelect,VTextField})
